import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { StarRating } from '../star-rating';
import { STAR_RATING_SECTION } from './index';
import * as styles from './average-star-rating-and-total.style';

interface StarRatingDisplayProps {
  rating: number;
  fillStar?: string;
  starSize: number;
  starGap: number;
  strokeColor?: string;
  strokeWidth?: number;
  section: STAR_RATING_SECTION;
  testIdPrefix?: string;
}

const StarRatingDisplay: React.FC<StarRatingDisplayProps> = ({
  rating,
  fillStar,
  starSize,
  starGap,
  strokeColor,
  strokeWidth,
  section,
  testIdPrefix = '',
}) => (
  <StackItem css={styles.starRating(section)} align="center">
    <StarRating
      rating={rating}
      fillStar={fillStar}
      starSize={starSize}
      starGap={starGap}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      data-testid={`${testIdPrefix}average-rating-stars`}
    />
  </StackItem>
);

export default StarRatingDisplay;
